import React, { useEffect, useState } from "react";
import "./Navbar.scss";
import { motion } from "framer-motion";
import logo from "../../assets/images/logo.png";
import Hamburger from "./Hamburger/Hamburger";
import { GiHamburgerMenu } from "react-icons/gi";
import { AiFillHome } from "react-icons/ai";
import { FaStickyNote } from "react-icons/fa";
import { BsFillTelephoneFill, BsFillBagFill } from "react-icons/bs";
import { IoIosInformationCircle } from "react-icons/io";
import { Link } from "react-scroll";

const Navbar = () => {
  const [toggle, setToggle] = useState(false);
  const [navbar, setNavbar] = useState(false);
  let activeHamburger = {
    display: "block",
  };

  let newNav = {
    padding: "3px 0px",
    backgroundColor: "#000",
    borderBottom: "1px solid rgba(255, 255, 255, 0.69)",
  };

  const changeBackground = () => {
    if (window.scrollY >= 100) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };
  useEffect(() => {
    changeBackground();
    window.addEventListener("scroll", changeBackground);
  });

  return (
    <nav style={navbar ? newNav : undefined}>
      <div className="page-container navbar">
        <div className="nav-logo">
          <Link to="home">
            <img src={logo} alt="logo" />
          </Link>
        </div>
        <div className="pages">
          <ul>
            <li>
              <Link
                to="home"
                spy={true}
                smooth={true}
                offset={-100}
                duration={50}
              >
                <AiFillHome />
              </Link>
            </li>
            <li>
              <Link
                to="about"
                spy={true}
                smooth={true}
                offset={-100}
                duration={50}
              >
                <IoIosInformationCircle />
              </Link>
            </li>
            <li>
              <Link
                to="resume"
                spy={true}
                smooth={true}
                offset={-70}
                duration={50}
              >
                <FaStickyNote />
              </Link>
            </li>
            <li>
              <Link
                to="portfolio"
                spy={true}
                smooth={true}
                offset={-60}
                duration={50}
              >
                <BsFillBagFill />
              </Link>
            </li>
            <li>
              <Link
                to="contact"
                spy={true}
                smooth={true}
                offset={-60}
                duration={50}
              >
                <BsFillTelephoneFill />
              </Link>
            </li>
          </ul>
        </div>
        <motion.div
          key={toggle}
          initial={{ top: -1, opacity: 0 }}
          animate={{ top: 0, opacity: 1 }}
          exit={{ bottom: -1, opacity: 0 }}
          transition={{
            duration: 0.1,
            opacity: { ease: "linear" },
          }}
          onClick={() => setToggle(!toggle)}
          className="hamburger"
        >
          {toggle ? (
            <span onClick={() => setToggle(!toggle)}>✖</span>
          ) : (
            <GiHamburgerMenu />
          )}
        </motion.div>
      </div>
      <Hamburger
        toggle={toggle}
        setToggle={setToggle}
        className="hambuger"
        style={toggle ? activeHamburger : undefined}
      />
    </nav>
  );
};

export default Navbar;
